import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { Card } from 'reactstrap';

const UserStatusTable = ({ students, loading }) => {
  const [userStatus, setUserStatus] = useState({
    total: 0,
    enrolled: 0,
    recommendedByFriends: 0,
    socialMedia: 0,
    banned: 0,
  });

  const userStatusColumnRow = [
    {
      title: "TOTAL",
      dataIndex: "total",
    },
    {
      title: "ENROLLED",
      dataIndex: "enrolled",
    },
    {
      title: "RECOMMENDED BY FRIENDS",
      dataIndex: "recommendedByFriends",
    },
    {
      title: "SOCIAL MEDIA",
      dataIndex: "socialMedia",
    },
    {
      title: "BANNED",
      dataIndex: "banned",
    },
  ];

  const calculateDataAnalytics = () => {
    const feeStatusTemp = {
      total: 0,
      enrolled: 0,
      recommendedByFriends: 0,
      socialMedia: 0,
      banned: 0,
    };

    for (const student of students) {
      if (student.howYouKnow?.includes("friend")) {
        feeStatusTemp.recommendedByFriends++;
      } else if (student.howYouKnow?.includes("Social")) {
        feeStatusTemp.socialMedia++;
      }
      if (student.banned) {
        feeStatusTemp.banned++;
      }
      if (student.courseIds) {
        feeStatusTemp.enrolled++;
      }
    }
    feeStatusTemp.total = students.length;
    setUserStatus(feeStatusTemp);
  };

  useEffect(() => {
    if (students.length) {
      calculateDataAnalytics();
    }
  }, [students]);

  return (
    <Card className='p-3'>
      <div className='ant-design-table not-margin'>
        <Table
          loading={loading}
          rowClassName={(record) => (record ? 'table-row-text' : '')}
          columns={userStatusColumnRow}
          dataSource={[userStatus]}
          scroll={{ x: 'auto' }}
          pagination={false}
        />
      </div>
    </Card>
  );
};

export default UserStatusTable;
